var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.buttonOption && Object.keys(_vm.buttonOption).length
    ? _c(
        "div",
        {
          class: `btn-trigger-wrap ${_vm.buttonOption.Alignment} ${
            _vm.sectionKey === _vm.activeButtonSectionKey &&
            _vm.buttonId === _vm.activeButtonId
              ? "active"
              : ""
          }`,
        },
        [
          _c(
            "div",
            {
              class: _vm.buttonOption.ImageAlignment,
              style: {
                width: `${_vm.buttonOption.Width === "fill" ? "100%" : "auto"}`,
              },
            },
            [
              _c(
                "a",
                {
                  class: _vm.getClassName,
                  style: _vm.renderStyles,
                  attrs: {
                    "data-section": _vm.sectionKey,
                    "data-id": _vm.buttonId,
                    href: _vm.getHref,
                    target: _vm.getTarget,
                  },
                  on: { click: _vm.clickButton },
                },
                [
                  _c("div", [
                    _vm.buttonOption.Icon
                      ? _c("i", {
                          class: `fa ${_vm.getIconExtra(
                            _vm.buttonOption.Icon
                          )} fa-${_vm.getIconName(_vm.buttonOption.Icon)}`,
                          style: {
                            color:
                              _vm.buttonOption.TextColor ||
                              _vm.theme.ButtonTextColor,
                            fontSize: `${_vm.buttonOption.IconSize || 14}px`,
                            marginRight: "10px",
                          },
                        })
                      : _vm._e(),
                    _c("div", [
                      _vm.buttonOption.Text
                        ? _c(
                            "span",
                            {
                              style: {
                                color:
                                  _vm.buttonOption.TextColor ||
                                  _vm.theme.ButtonTextColor,
                                fontSize: `${
                                  _vm.buttonOption.FontSize || 14
                                }px`,
                                fontWeight: 600,
                                fontFamily: _vm.disableFontFamily
                                  ? "'Poppins', sans-serif"
                                  : _vm.buttonOption.FontFamily,
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.buttonOption.Text) + " ")]
                          )
                        : _vm._e(),
                      _vm.buttonOption.SubText
                        ? _c(
                            "span",
                            {
                              style: {
                                color:
                                  _vm.buttonOption.SubTextColor ||
                                  _vm.theme.ButtonTextColor,
                                fontSize: `${
                                  _vm.buttonOption.SubFontSize || 14
                                }px`,
                                fontWeight: 400,
                                fontFamily: _vm.disableFontFamily
                                  ? "'Poppins', sans-serif"
                                  : _vm.buttonOption.FontFamily,
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.buttonOption.SubText) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm.buttonOption.IconAfter
                      ? _c("i", {
                          class: `fa ${_vm.getIconExtra(
                            _vm.buttonOption.IconAfter
                          )} fa-${_vm.getIconName(_vm.buttonOption.IconAfter)}`,
                          style: {
                            color:
                              _vm.buttonOption.TextColor ||
                              _vm.theme.ButtonTextColor,
                            fontSize: `${_vm.buttonOption.IconSize || 14}px`,
                            marginLeft: "10px",
                          },
                        })
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm.buttonOption.ShowImage && _vm.buttonOption.Image
                ? [
                    _vm.buttonOption.ShowWidth && _vm.buttonOption.ShowHeight
                      ? [
                          _c("img", {
                            attrs: {
                              src: _vm.buttonOption.Image,
                              width: _vm.buttonOption.ShowWidth,
                              height: _vm.buttonOption.ShowHeight,
                              alt: "",
                            },
                          }),
                        ]
                      : [
                          _c("img", {
                            attrs: { src: _vm.buttonOption.Image, alt: "" },
                          }),
                        ],
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }